import { useParams } from '@suntex.core/nav'
import { EntityLevel } from '@suntex.fim/enums'

interface Params {
  entityLevel: EntityLevel
  entityId: number
}

function useTypedParams(): Params {
  const { entityLevel, entityId } = useParams()

  return {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    entityLevel: (EntityLevel as any)[
      entityLevel
        ? entityLevel.charAt(0).toUpperCase() + entityLevel.slice(1)
        : ''
    ],
    entityId: Number(entityId!)
  }
}

function AdminEntityEdit() {
  //do this until we can secure it by verifying that the user is an admin
  return <>Under construction</>
}

export default AdminEntityEdit
